import request from '@/fetch/index'

// 通过 银行 ID 获取支行
export function getBranchBankList (params) {
  return request({
    url: '/api/loan/bankInfo/app/',
    methods: 'GET',
    params
  })
}

// 获取合作银行列表
export function getCoopBankList() {
  return request({
    url: '/api/loan/bankInfo/app/partner',
    methods: 'GET'
  })
}

/**
 * 灰度机构判断
 * @param {id} 机构 id
 * @returns { bool }
 */
export function judgeIsGrayOrg ({ id }) {
  return request({
    url: `/api/loan/open-platform/grey/organization/${id}`,
    method: 'GET'
  })
}
